<template>
  <div class="withdraw" v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="main">
          <div class="heard">
              我要提现
          </div>
          <p class="topp" v-show="WithdrawChannellist.length">温馨提醒: 
            <span v-show="AllowPayTime || ForbidHolidayPay">提现时间段为
              <span v-show="ForbidHolidayPay">工作日</span>
              <span>{{ AllowPayTime }}</span>, 
            </span>
            <span v-show="SingleLimit">
              每笔限额 {{ SingleLimit }} {{ LimitMoneyType === 0 ? CurrencyName : '人民币' }}, 
            </span>
            <span v-show="SingleDayLimit">
              每天累积限额 {{ SingleDayLimit }} {{ LimitMoneyType === 0 ? CurrencyName : '人民币' }}
            </span>
          .</p>
          <div class="conter" style="margin-top: 20px;">
            <div style="margin: 20px 0px;width:90%;padding-left: 98px;" class="clearfix" >
              <el-radio v-model="radio" border :label="index + ''" v-for="(item,index) in WithdrawChannellist" :key="index" @change="GetExchangeRate(index)" v-show="!(item.Code == 'usdt' && insTestProp.EnabledUsdt == false)"> <span class="PayChanneltext">{{item.Name}}</span> </el-radio>
            </div>
              <el-form :label-position="labelPosition" label-width="110px" :model="PrePaydata">
                <el-form-item label="银行卡号：" v-show="WithdrawChannelCode == 'offline'">
                  <el-input v-model="bankid" disabled=""  size="small"></el-input>
                  <div class="formrightboxa">
                      <el-button class="formbtn " size="mini" v-show="show" @click="setbankcode()">绑定</el-button>
                  </div>
                </el-form-item>
                <el-form-item label="USDT钱包：" v-show="WithdrawChannelCode == 'usdt' && UsdtAccount && insTestProp.EnabledUsdt">
                  <el-input v-model="UsdtAccount" disabled=""  size="small"></el-input>
                </el-form-item>                
                <!-- <el-form-item label="钱包姓名：" v-show="WithdrawChannelCode == 'yilianpayh5'">
                  <el-input v-model="WalletOpenResult.AccName" disabled=""  size="small"></el-input>
                  <div class="formrightboxa">
                      <el-button size="mini" type="primary" v-show="!WalletOpenResult.IsOpen" @click="openWallet()">开通有钱钱包</el-button>
                  </div>
                </el-form-item> -->
                <!-- <el-form-item label="钱包账户：" v-show="WithdrawChannelCode == 'yilianpayh5'">
                  <el-input v-model="WalletOpenResult.AccNo" disabled=""  size="small"></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="钱包余额：" v-show="WithdrawChannelCode == 'yilianpayh5'">
                  <el-input v-model="WalletOpenResult.Amount" disabled=""  size="small"></el-input>
                </el-form-item> -->
                <el-form-item label="提现账户：" >
                  <el-input v-model="PrePaydata.ClientKey" disabled=""  size="small"></el-input>
                </el-form-item>
                 <el-form-item label="账户余额：">
                  <el-input v-model="CurrWithdrawAble" disabled=""  size="small"></el-input>
                  <span class="unit">{{CurrencyName}}</span>
                </el-form-item>
                 <el-form-item label="提现金额：">
                  <el-input v-model="PrePaydata.Money" auto-complete="new-password" placeholder="请输入提现金额"   type="text"   @input="changemoney()"   @blur.prevent="setmoney()"  size="small"></el-input>
                  <span class="unit">{{CurrencyName}}</span>
                   <span class="units" v-show="units">*输入金额超出可提现金额</span>
                </el-form-item>
                <el-form-item label="实到金额：">
                  <el-input v-model="RateMoney"    disabled="disabled"    size="small"></el-input>
                  <span class="unit">{{Unit}}</span>
                </el-form-item>
                <el-form-item label="汇率：">
                  <el-input v-model="Rate"    disabled="disabled"    size="small"></el-input>
                </el-form-item>
                <el-form-item :label="insTestProp.UserRelyPhone ? '验证码：' : '登陆密码：'" prop="code">
                  <el-input auto-complete="new-password" :type="insTestProp.UserRelyPhone ? 'text' : 'password'" v-model="PrePaydata.VerifyCode" placeholder="请输入内容" style="width:50%;float:left;"  size="small"></el-input>
                   <el-button v-show="insTestProp.UserRelyPhone" type="primary" class=""  @click="sendCode()" :disabled="isDisabled" style="float:  left;margin-left:  20px;">{{buttonName}}</el-button>
                </el-form-item>
                <!-- <p class="p">注:最小金额为1{{CurrencyName}}</p> -->
              </el-form>
                <el-button type="primary" class="btn" :disabled="isDisableds" @click="PrePay()" style="font-size:20px;margin-bottom: 50px;">立即提现</el-button>
          </div>
      </div>
      <wallet ref="wallet"></wallet>
  </div>
</template>

<script>
import api from "../../static/config.json";
import "../assets/lib/jquery.min.js";
import Bus from "@/assets/js/bus";
import wallet from "@/components/modification/wallet.vue";
export default {
  name: "withdrawdeposit",
  components: {
    wallet
  },
  data() {
    return {
      Date:"",
      Date1:"",
      show:"",
      showusdt:"",
      labelPosition: "right",
      buttonName: "发送短信验证码",
      code: "",
      loading: false,
      units: false,
      isDisabled: false,
       isDisableds: false,
      bankCard: {},
      bankid: "",
      UsdtAccount:"",
      phone: "",
      time: 60,
      CurrWithdrawAble: "",
      RateMoney:0,
      PrePaydata: {
        Money: "",
        VerifyCode: "",
        ClientKey: "",
        VerifyCodeKey: "",
        WithDrawChannelCode: "",
      },
      insTestProp: {
        IsTestIns: true, // 是否测试机构，true测试机构
        UserRelyPhone: true, // 依赖手机号
        UseCustomId: true, // 使用自定义ID,false表示使用系统自动生成，true表示使用自定义ID
        EnabledUsdt: false
      },
      WithdrawChannelName: '', //通道名称
      WithdrawChannelCode: '', //通道code
      SingleLimit: 0, // 单笔限额
      SingleDayLimit: 0, // 累积限额
      LimitMoneyType: 0, // 金额类型 0美元 1人民币
      AllowPayTime: '', // 允许提现的时间
      ForbidHolidayPay: false, // 禁止节假日支付
      WithdrawChannellist: [], //提现通道
      radio: '0',
      WalletOpenResult: {
        IsOpen: false,
        Amount: '',
        AccNo: '',
        AccName: ''
      }, // 有钱钱包开通结果
      CurrencyName: '',
      Unit:'',
      Rate:''
    };
  },
  mounted() {
    this.insTestProp = JSON.parse(sessionStorage.getItem("insTestProp"));
    console.log(this.insTestProp.EnabledUsdt);
    if (this.insTestProp.UserRelyPhone) {
      this.getphone();
    }
  },
  created() {
    this.PrePaydata.ClientKey = sessionStorage.getItem("uname");
    this.getBalanceInfo();
    
    this.GetWithDrawChannel();
    this.getCurrencyName();
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    // 切换提现通道
    GetExchangeRate (index) {
      this.WithdrawChannelName = this.WithdrawChannellist[index].Name;
      this.WithdrawChannelCode = this.WithdrawChannellist[index].Code;
      this.SingleLimit = this.WithdrawChannellist[index].SingleLimit;
      this.SingleDayLimit = this.WithdrawChannellist[index].SingleDayLimit;
      this.LimitMoneyType = this.WithdrawChannellist[index].LimitMoneyType;
      this.AllowPayTime = this.WithdrawChannellist[index].AllowPayTime;
      this.ForbidHolidayPay = this.WithdrawChannellist[index].ForbidHolidayPay;
      this.Unit=this.WithdrawChannellist[index].Unit;
      this.Rate=this.WithdrawChannellist[index].Rate;
      this.RateMoney=this.PrePaydata.Money/this.WithdrawChannellist[index].Rate;
      if(this.WithdrawChannelCode == 'offline') {
        this.getbankcode();
      }
      if(this.WithdrawChannelCode == 'usdt') {
        this.getusdtaccount();
      }
      if(this.WithdrawChannelCode == 'yilianpayh5') {
        this.QryWalletOpenResult();
      }
    },
    QryWalletOpenResult () {
      let url = "/Wallet/QryWalletOpenResult";
      let postData = "";
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.WalletOpenResult.IsOpen = response.Data.IsOpen;
          this.WalletOpenResult.Amount = response.Data.Amount;
          this.WalletOpenResult.AccNo = response.Data.AccNo;
          this.WalletOpenResult.AccName = response.Data.AccName;
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // openWallet () {
    //   this.$refs.wallet.WalletOpenAccountPre();
    // },
    // 获取提现通道信息
    GetWithDrawChannel () {
      let url = "/Account/GetWithDrawChannels";
      let postData =  "";
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          var url_ = "/Wallet/CanUseWallet";
          var postData_ = "";
          this.$loginapi.post(url_, postData_, res => {
            if (res.Ret == 0) {
              if (res.Data) { // 有钱包功能
                this.WithdrawChannellist = [];
                response.Data.forEach(item => {
                  if (item.Code != 'offline') {
                    this.WithdrawChannellist.push(item);
                  }
                })
              } else {
                this.WithdrawChannellist = response.Data;
              }
              if (this.WithdrawChannellist.length) {
                this.WithdrawChannelName = this.WithdrawChannellist[0].Name;
                this.WithdrawChannelCode = this.WithdrawChannellist[0].Code;
                this.SingleLimit = this.WithdrawChannellist[0].SingleLimit;
                this.SingleDayLimit = this.WithdrawChannellist[0].SingleDayLimit;
                this.LimitMoneyType = this.WithdrawChannellist[0].LimitMoneyType;
                this.AllowPayTime = this.WithdrawChannellist[0].AllowPayTime;
                this.ForbidHolidayPay = this.WithdrawChannellist[0].ForbidHolidayPay;
                this.Unit=this.WithdrawChannellist[0].Unit;
                this.Rate=this.WithdrawChannellist[0].Rate;
                if(this.WithdrawChannelCode == 'offline') {
                  this.getbankcode();
                }
                if(this.WithdrawChannelCode == 'yilianpayh5') {
                  this.QryWalletOpenResult();
                }
              }
            }
          });
          
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 发送验证码
    sendCode() {
      if(this.PrePaydata.Money <= 0){
        this.$message.error("请输入正确金额");
        return;
      }
      this.sendMsg();
      let url = "login/SendVerifyCodeToPhone";
      let postData =  "phone=" + this.phone ;
      this.$api.post(url, postData, response => {
        if (response.Ret == 0) {
          this.$message.success("验证码发送成功！");
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 短信验证倒计时
    sendMsg() {
      let me = this;
      me.isDisabled = true;
      let interval = window.setInterval(function() {
        me.buttonName = "（" + me.time + "s）重新发送";
        --me.time;
        if (me.time < 0) {
          me.buttonName = "发送短信验证码";
          me.time = 60;
          me.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    // 提现
    PrePay() {
      
      // if (this.PrePaydata.Money == "") {
      //   this.$message.error("提现金额不能为空！");
      //   return;
      // } else  if(this.units == true){
      //   this.$message.error("请输入一个正确的金额！");
      //   return;
      // }
      if (this.insTestProp.UserRelyPhone) {
        if (this.PrePaydata.VerifyCode == "") {
          this.$message.error("验证码不能为空！");
          return;
        }
       } else {
         if (this.PrePaydata.VerifyCode == "") {
            this.$message.error("登录密码不能为空！");
            return;
          }
       }
      // 判断是否开通钱包功能
      if (this.WithdrawChannelCode == 'yilianpayh5') {
        let url = "/Wallet/QryWalletOpenResult";
        let postData = "";
        this.$loginapi.post(url, postData, response => {
          if (response.Ret == 0) {
            if(response.Data.IsOpen) { // 已经开通有钱钱包
              this.PrePaydata.WithDrawChannelCode = this.WithdrawChannelCode;
              this.isDisableds = true;
              var data = this.PrePaydata;
              var url = "/Account/WithdrawNew";
              this.$loginapi.post(url, data, response => {
                if (response.Ret == 0) {
                  this.$message.success(response.Msg);
                  this.$router.push("/index");
                  Bus.$emit("activeIndex1", "/index");
                  this.isDisableds = false;
                } else {
                  this.isDisableds = false;
                  this.$message.error(response.Msg);
                }
              });
            } else { // 未开通有钱钱包
              this.$alert("未开通有钱钱包功能，是否去开通有钱钱包?", "", {
                showCancelButton: true,
                confirmButtonText: "开通",
                callback: action => {
                  if (action == "confirm") {
                    // this.$refs.wallet.WalletOpenAccountPre();
                    this.openWallet();
                  }
                }
              });
            }
          } else {
          }
        });
      } else {
        if(this.WithdrawChannelCode == 'offline') {
          if (this.show) {
            this.$message.error("账户未绑定银行卡，请先绑定银行卡！");
            return;
          }
        }
        if(this.WithdrawChannelCode == 'usdt') {
          if (this.showusdt) {
            this.$message.error("请先绑定USDT钱包后再提现！");
            return;
          }
        }
        this.PrePaydata.WithDrawChannelCode = this.WithdrawChannelCode;
        this.isDisableds = true;
        var data = this.PrePaydata;
        var url = "/Account/WithdrawNew";
        this.$loginapi.post(url, data, response => {
          if (response.Ret == 0) {
            this.$message.success(response.Msg);
            this.$router.push("/index");
            Bus.$emit("activeIndex1", "/index");
            this.isDisableds = false;
          } else {
            this.isDisableds = false;
            this.$message.error(response.Msg);
          }
        });
      }
    },
    openWallet () {
      let url = "/Wallet/AuthOper";
      let postData =  {
        OperType: 'real',
        Source: 2
      };
      this.loading = true;
      this.$loginapi.post(url, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          window.open(response.Data)
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    changemoney(){
      this.RateMoney=this.PrePaydata.Money/this.Rate;
    },
    setmoney() {
      
      this.PrePaydata.Money = String(this.PrePaydata.Money);
      this.PrePaydata.Money = this.PrePaydata.Money.replace(/[^\d^\.]+/g,'');
      this.PrePaydata.Money = this.PrePaydata.Money.replace(/\b(0+)/gi, "");
      if(this.PrePaydata.Money.indexOf(".") != -1){
        this.PrePaydata.Money = Number(this.PrePaydata.Money);
        if(isNaN(parseInt(this.PrePaydata.Money))){
           this.$message.warning("请输入一个正确的金额！");
           this.PrePaydata.Money = ""
        }
        this.PrePaydata.Money =  this.num(this.PrePaydata.Money,2)
        // this.PrePaydata.Money = this.PrePaydata.Money.toFixed(2);
      }
      this.PrePaydata.Money = Number(this.PrePaydata.Money);
      // this.changemoney();
      this.CurrWithdrawAble = Number(this.CurrWithdrawAble);
      if (this.PrePaydata.Money > this.CurrWithdrawAble) {
        this.units = true;
        this.isDisabled = true;
      } else {
        this.units = false;
        this.isDisabled = false;
      }
    },
    num(digit, length){
          length = length ? parseInt(length) : 0;
          if (length <= 0) return Math.round(digit);
          digit = Math.round(digit * Math.pow(10, length)) / Math.pow(10, length);
          return digit;
    },
    // 跳转弹框
    open() {
      if (this.phone == "" || this.phone == null) {
        this.$alert("账户未绑定手机号，请先绑定手机号！", "", {
          confirmButtonText: "确定",
          callback: action => {
            this.$router.push("/modification/phone");
            Bus.$emit("activeIndex4", "");
          }
        });
      }
    },
    // 获取银行卡号
    getbankcode() {
      let url = "/Account/QueryBankCards";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.bankid = response.Data[0].CardNO;
             this.show = false;
             this.UsdtAccount = response.Data[0].UsdtAccount;

          } else {
             this.bankid = "账户未绑定银行卡，请先绑定银行卡！";
             this.show = true;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 获取usdt钱包
    getusdtaccount() {
      let url = "/Account/QueryUsdtAccounts";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
             this.showusdt = false;
             this.UsdtAccount = response.Data[0].AccountNO;

          } else {
             this.UsdtAccount = "账户未绑定USDT钱包！";
             this.showusdt = true;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //获取账户余额
    getBalanceInfo() {
      let url = "/Account/GetBalance";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          this.CurrWithdrawAble = response.Data.CurrWithdrawAble;
          this.CurrWithdrawAble = this.CurrWithdrawAble.toFixed(2);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 获取绑定手机号
    getphone() {
      let url = "/Account/GetUserInfo";
      this.$loginapi.post(
        url,
        this.$store.state.userInfo.UserCode,
        response => {
          if (response.Ret == 0) {
            this.phone = response.Data.BindPhone;
            this.PrePaydata.VerifyCodeKey = response.Data.BindPhone;
             this.open();
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    setbankcode() {
      this.$router.push("/modification/bankcode");
    }
  }
};
</script>

<style>
.withdraw .PayChanneltext{
  font-size: 25px;
  color: #000;
  display: inline-block;
  padding: 0 10px;
  font-family: cursive;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/withdrawdeposit.vue